module.exports = __webpack_public_path__ + "static/PUNTO-2-a57dd52987e09f66745e4546c68e4b3f.png";